import React, { Component } from 'react';
import { connect } from 'react-redux';
import './SortingMenu.css';
import { changeCategorySorting } from '../../../../redux/actions';
import SortingButton from './SortingButton/SortingButton';

class SortingMenu extends Component {
  getSortButton(buttonId) {
    return (<SortingButton
      buttonId={buttonId}
      sorting={this.props.sorting}
      sortingSwitch={this.props.changeCategorySorting}
    />);
  }

  render() {
    return (
      <div className="sort-wrap">
        <div className="sort-section title">
          <div className="name">Dle názvu</div>
          { this.getSortButton(0) }
          { this.getSortButton(1) }
        </div>
        <div className="sort-section">
          <div className="name">Dle data</div>
          { this.getSortButton(2) }
          { this.getSortButton(3) }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sorting: state.dataCategory.sorting,
});

const mapDispatchToProps = dispatch => ({
  changeCategorySorting: sorting => dispatch(changeCategorySorting(sorting)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SortingMenu);



// WEBPACK FOOTER //
// ./src/components/App/CategoryPage/SortingMenu/SortingMenu.js